/**
 * Regex Patterns Module - Паттерны и утилиты для поиска
 */

(function(window) {
    'use strict';

    // Экспортируемые функции
    const RegexPatterns = {};

    /**
     * Заменяет специальные символы в паттерне
     */
    RegexPatterns.qRep = function(inp, simple = false, extraReplace = '') {
        inp = inp.replace(/(?<!\))\?(?!:)/g, '[^\\s/]').replace(/\*/g, (simple ? '.*' : `[${reNonBoundaryE}]*`));
        if (extraReplace != '') { 
            inp = inp.replace(new RegExp(extraReplace, 'g'), (simple ? '.*' : `[^${reNonBoundaryE}]+`));
        }
        return inp;
    };

    /**
     * Экранирует специальные символы regex
     */
    RegexPatterns.escapeRegExp = function(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    /**
     * Класс для работы с датами в формате YY-MM-DD
     */
    RegexPatterns.DateFromTo = class {
        constructor(inputDate, start) {
            this.inputDate = inputDate;
            // Strict numeric YY-MM-DD; non-numeric input falls back to safe defaults.
            var m = inputDate.match(/^(\d{2})-(\d{2})-(\d{2})$/);
            m = m || [null, null, null];

            this.year = (isInt(m[1]) ? m[1] : (start ? "50" : "99"));
            this.month = (isInt(m[2]) ? m[2] : (start ? "01" : "12"));
            this.day = (isInt(m[3]) ? m[3] : (start ? "01" : "31"));
            this.yearN = Number(this.year);
            this.monthN = Number(this.month);
            this.dayN = Number(this.day);
            this.rx = [this.year, this.month, this.day];
        }
    };

    /**
     * Генерирует regex паттерн для диапазона
     */
    function rFromTo(f, t) {
        let ft = "";
        let f1N = Number(f.charAt(0));
        let t1N = Number(t.charAt(0));
        let t2N = Number(t.charAt(1));
        
        if (t < f) { throw "To is less than From"; }
        
        ft = f.charAt(0);
        if (f1N == t1N) {
            if (f.charAt(1) == t.charAt(1)) {
                ft += f.charAt(1);
            } else {
                ft += "[" + f.charAt(1) + "-" + t.charAt(1) + "]";
            }
        } else {
            ft += "[" + f.charAt(1) + "-9]";
            if (t1N - f1N > 2) {
                ft += "|[" + (f1N + 1).toString() + "-" + (t1N - 1).toString() + "]" + "\\d";
            } else if (t1N - f1N > 1) {
                ft += "|[" + (f1N + 1).toString() + "]" + "\\d";
            }
            if (t1N - f1N > 0) {
                ft += "|" + t1N.toString() + (t2N > 0 ? "[0-" + t2N.toString() + "]" : "0");
            }
        }
        return "(?:" + ft + ")";
    }

    /**
     * Дополняет строку нулями слева
     */
    function padBack(n) { 
        return n.toString().padStart(2, '0'); 
    }

    /**
     * Обогащает месяц дополнительными вариантами
     */
    function monthEnrich(rx, mF, mT) {
        mT = mT || mF; 
        mT += 1;
        let m = monthReplace(range(mF, mT));
        let ret = "(?:" + rx + (m ? "|(?:" + m + ")" : "") + ")";
        return ret;
    }

    /**
     * Генерирует паттерны для диапазона дат
     */
    function dateRangePatterns(y, m, d) {
        m[1] = Number(m[1]);
        if (m.length == 2) { m.push(m[1]); }
        m[2] += 1;
        let mNames = monthReplace(range(m[1], m[2]));
        let patterLeft = y + "(?:" + m[0] + (mNames ? "|(?:" + mNames + ")" : "") + ")" + d;
        let patterRight1 = d + "(?:" + m[0] + (mNames ? "|(?:" + mNames + ")" : "") + ")" + y;
        let patterRight2 = (mNames ? "(?:" + mNames + ")" : "") + d + y;
        return [patterLeft, patterRight1, patterRight2];
    }

    /**
     * Заменяет месяцы на regex паттерны
     */
    function monthReplace(monStr, leftSide = true, namesOnly = false) {
        let reps = {
            "01": {
                "short": ["Jan", "Янв"],
                "full": ["January", "Январь", "января", "Января"]
            },
            "02": {
                "short": ["Feb", "Фев"],
                "full": ["February", "Февраль", "февраля", "Февраля"]
            },
            "03": {
                "short": ["Mar", "Мар"],
                "full": ["March", "Март", "марта", "Марта"]
            },
            "04": {
                "short": ["Apr", "Апр"],
                "full": ["April", "Апрель", "апреля", "Апреля"]
            },
            "05": {
                "short": ["May", "Май"],
                "full": ["May", "Май", "мая", "Мая"]
            },
            "06": {
                "short": ["Jun", "Июн"],
                "full": ["June", "Июнь", "июня", "Июня"]
            },
            "07": {
                "short": ["Jul", "Июл"],
                "full": ["July", "Июль", "июля", "Июля"]
            },
            "08": {
                "short": ["Aug", "Авг"],
                "full": ["August", "Август", "августа", "Августа"]
            },
            "09": {
                "short": ["Sep", "Сен"],
                "full": ["September", "Сентябрь", "сентября", "Сентября"]
            },
            "10": {
                "short": ["Oct", "Окт"],
                "full": ["October", "Октябрь", "октября", "Октября"]
            },
            "11": {
                "short": ["Nov", "Ноя"],
                "full": ["November", "Ноябрь", "ноября", "Ноября"]
            },
            "12": {
                "short": ["Dec", "Дек"],
                "full": ["December", "Декабрь", "декабря", "Декабря"]
            }
        };

        let replacements = [];
        
        if (monStr === 'all') {
            // Все месяцы
            for (let key in reps) {
                if (!namesOnly) replacements.push(key);
                replacements.push(...reps[key].short);
                replacements.push(...reps[key].full);
            }
        } else if (reps[monStr]) {
            // Конкретный месяц
            if (!namesOnly) replacements.push(monStr);
            replacements.push(...reps[monStr].short);
            replacements.push(...reps[monStr].full);
        }

        return replacements.length > 0 ? "(?:" + replacements.join("|") + ")" : monStr;
    }

    /**
     * Создает паттерн поиска по дате
     */
    RegexPatterns.docGetPatternSearchByDate = function(searchDate, strictIssue = false) {
        let m = searchDate.match(/^([ТтBbIi]?[A-ZА-ЯЁa-zа-яё]{1,2})?([\d?*]{2})([\d?*]{2}|[\d?*]{1}$)?([A-Za-zА-ЯЁа-яё?*]{1,2})?(([\d?*]{1,2})(-?[\d?*]{1})?(\w*))?/);
        
        let mDay = m[6] || "", mRevision = m[8] || "", mBulletingCode = m[1];
        let mMonth = m[3] || "";
        let mYear = (m[2] ? m[2] : "");
        let mTapeCode = m[4] || "";
        let mIssue = m[7] || "";
        
        let patYear = (mYear != "" ? (isNumeric(mYear) ? (Number(mYear) >= 50 && Number(mYear) <= 99 ? "(?:19)?" : "") + mYear : (RegexPatterns.qRep(mYear))) : "");
        
        let searchDateStraight = (mBulletingCode ? RegexPatterns.qRep(mBulletingCode) + (mBulletingCode.length == 1 ? "[A-ZА-ЯЁ]?" : "") + " ?" : "") + patYear
            + (mMonth == "??" ? monthReplace('all') : (mMonth == "" ? "" : monthReplace(mMonth)))
            + ((mDay + mRevision) != "" ? (mTapeCode != "" ? RegexPatterns.qRep(mTapeCode) : "(?:[A-Za-z]{1,2})?") : "") 
            + RegexPatterns.qRep(mDay) + (mIssue != "" ? "(?:-|\\s+Issue\\s+)?" + RegexPatterns.qRep(mIssue) : "") 
            + (!strictIssue ? RegexPatterns.qRep(mRevision) : `(?![-\\d]|\\s+Issue)(?=\\b|[^${reAllLetters2}])`);
        
        let result = [];
        if (mMonth) {
            // Обработка с месяцем
            let dayPart = (mDay != "" ? RegexPatterns.qRep((mDay.length == 1 ? mDay + "?" : (mDay.substring(0, 1) == "0" ? "(?:\\b" + mDay.substring(1, 2) + "|" + mDay + ")" : mDay))) : "\\d*");
            let monPart1 = (mMonth == "??" ? monthReplace('all') : (mMonth == "" ? "" : monthReplace(mMonth, false)));
            let monPart2 = (mMonth == "??" ? monthReplace('all', false, true) : (mMonth == "" ? "" : monthReplace(mMonth, false, true)));
            
            let searchDateReverse = (mDay != "" ? "" : "(?<=") + (mBulletingCode ? RegexPatterns.qRep(mBulletingCode) + (mBulletingCode.length == 1 ? "[A-ZА-ЯЁ]?" : "") + " ?" : "")
                + ("(?:(?:" + dayPart + monPart1 + ")|(?:" + monPart2 + "[\\s.,-]*" + dayPart + "))[\\s.,-]*") + patYear
                + (mIssue != "" ? "(?:-|\\s+Issue\\s+)?" + RegexPatterns.qRep(mIssue) : "") 
                + (!strictIssue ? RegexPatterns.qRep(mRevision) + `(?=\\b|[${reAllLetters2}])` : `(?![-\\d]|\\s+Issue)(?=\\b|[^${reAllLetters2}])`);
            
            result.push({ "condition": "or", "value": [searchDateStraight, searchDateReverse], "modifier": "i" });
        } else { 
            result.push({ "condition": "or", "value": [searchDateStraight], "modifier": "i" }); 
        }
        return result;
    };

    // Экспорт внутренних функций для использования в модуле
    RegexPatterns._internal = {
        rFromTo,
        padBack,
        monthEnrich,
        dateRangePatterns,
        monthReplace
    };

    // Экспорт модуля
    window.RegexPatterns = RegexPatterns;

    // ES Module export for modern imports
    if (typeof window !== 'undefined') {
        window.searchPatterns = RegexPatterns;
    }

})(window); 

// ES Module export
export const searchPatterns = window.RegexPatterns || {}; 